/* eslint-disable global-require */
import chroma from 'chroma-js';
import { Platform } from 'react-native';
import Icon from '../../../components/common/Icon';

const colors = {
  backgroundColor: '#FBFBFB',
  dashboardBackgroundColor: '#EEEEEE',
  primaryColor: '#FF0000',
  secondaryColor: '#0000FF',
  tertiaryColor: '#0000FF',
  fourthColor: '#6259EC',
  fifthColor: '#0097E5',
  sixthColor: '#00E5AC',
  seventhColor: '#E93323',
  eighthColor: '#DDDDF0',
  neutralColor: '#9B9B9B',
  overPrimaryColor: 'white',
  overSecondaryColor: 'white',
  gray: {
    normal: '#5E5E5E',
    normalLight: '#9B9B9B',
    light: '#DDDDDF',
    lightBackground: '#F5F5F5',
    selectedBackground: '#EEEEEE',
  },
  white: '#FFFFFF',
  errorColor: 'red',
  overErrorColor: 'white',
  errorBackgroundColor: '#FCEBED',
  passwordStrength: {
    error: '#DC143C',
    warning: '#F7C269',
    notice: '#A8F070',
    ok: '#90EE90',
  },
};

const inferredColors = {
  overPrimaryColorWithLessImpedance: chroma(colors.overPrimaryColor)
    .alpha(0.53)
    .css(),
  transparentPrimaryColor: chroma(colors.primaryColor).alpha(0.6).css(),
  transparentOverPrimaryColor: chroma(colors.overPrimaryColor).alpha(0.6).css(),
  transparentSecondaryColor: chroma(colors.secondaryColor).alpha(0.6).css(),
  veryTransparentSecondaryColor: chroma(colors.secondaryColor).alpha(0.2).css(),
};

const ui = {
  IconComponent: Icon,
  buttons: {
    commonStyle: {
      textTransform: 'none',
      borderRadius: 5,
    },
    PRIMARY: {
      backgroundColors: [
        colors.primaryColor,
        colors.primaryColor,
        colors.primaryColor,
      ],
      textColor: colors.white,
    },
    SECONDARY: {
      backgroundColor: colors.secondaryColor,
      borderColor: colors.secondaryColor,
      textColor: colors.white,
    },
    TERTIARY: {
      backgroundColor: colors.white,
      borderColor: colors.tertiaryColor,
      textColor: colors.tertiaryColor,
    },
    LINK: {
      hasRightArrow: true,
      color: colors.primaryColor,
    },
    SUCCESS: {
      backgroundColors: [
        colors.primaryColor,
        colors.primaryColor,
        colors.primaryColor,
      ],
      textColor: colors.white,
    },
    DEFAULT: {
      backgroundColors: [colors.white, colors.white, colors.white],
      borderColor: '#ABABAB',
      textColor: '#ABABAB',
    },
    CANCEL: {
      backgroundColors: [
        colors.secondaryColor,
        colors.secondaryColor,
        colors.secondaryColor,
      ],
      borderColor: colors.secondaryColor,
      textColor: colors.white,
    },
    borderRadius: 5,
  },
  colors: {
    background: '#FBFBFB',
    black: '#000000',
    frame: {
      backgroundColor: colors.white,
      textColor: colors.gray.normal,
      linkColor: colors.primaryColor,
    },
    gray: {
      dark: 'gray',
      light: '#DDDDDF',
      normal: '#5E5E5E',
    },
    neutral: '#0000FF',
    primary: {
      dark: '#FF0000',
      light: '#FF0000',
      normal: '#FF0000',
    },
    secondary: {
      dark: '#0000FF',
      light: '#0000FF',
      normal: '#0000FF',
    },
    status: {
      disabled: '#5E5E5E',
      error: 'red',
      success: '#90ee90',
      warning: '#c0f149',
    },
    transparent: 'transparent',
    white: '#FFFFFF',
  },
  font: {
    family: 'Gotham',
    size: {
      large: 18,
      medium: 16,
      regular: 14,
      small: 12,
      xLarge: 20,
      xSmall: 10,
    },
    weight: {
      bold: '600',
      light: '300',
      normal: '500',
    },
  },
  icons: {
    arrowRight: 'arrow-right',
  },
  spacing: {
    unit: 8,
  },
};

export default {
  name: 'Kaizen',
  ...colors,
  ...inferredColors,
  frame: {
    backgroundColor: colors.white,
    textColor: colors.gray.normal,
    linkColor: colors.primaryColor,
  },
  brandIcon: require('./img/brand_icon.png'),
  cardMaskImage: require('./img/card_mask.png'),
  creditCardImage: require('./img/credit_card.png'),
  failurePhoneImage: require('./img/failure_phone.png'),
  font: ui.font,
  footerImage: null,
  identityCardImage: require('./img/identity_requirement.png'),
  inactiveSimCardImage: require('./img/inactive_sim.png'),
  internationalImage: require('./img/idd_offer.png'),
  invalidInviteAFriend: require('./img/invalid_invite_a_friend.png'),
  inviteAFriend: require('./img/invite_a_friend.png'),
  lineTerminationSuccessImage: require('./img/line_termination_success.png'),
  logoImage: require('./img/logo.png'),
  lostAndStolenImage: require('./img/lost_and_stolen.png'),
  noPendingImage: require('./img/no_pending_delivery.png'),
  onboardingImages: [
    require('./img/onboarding_screen_1.png'),
    require('./img/onboarding_screen_2.png'),
    require('./img/onboarding_screen_3.png'),
  ],
  orderFailedImage: require('./img/icon_order_failed.png'),
  paypalLogo: require('./img/paypal_logo.png'),
  paypalVerticalImage: require('./img/paypal_vertical.jpg'),
  selfieImage: require('./img/selfie_shape.png'),
  simCardOnItsWayImage: require('./img/sim_card_on_its_way.png'),
  simReplacementImage: require('./img/sim_replacement.png'),
  successPhoneImage: require('./img/success_phone.png'),
  swapSimImage: require('./img/swap_sim_card.png'),
  terminationImage: require('./img/termination.png'),
  travelImage: require('./img/roaming_pack_offer.png'),
  visaLogo: require('./img/visa_logo.png'),
  mastercardLogo: require('./img/mastercard_logo.png'),
  cbLogo: require('./img/cb_logo.png'),
  voucherImage: require('./img/voucher_bg.jpg'),
  wellDoneImage: require('./img/well_done.png'),
  eSimImage: require('./img/esim.png'),
  simCardImage: require('./img/simcard.png'),
  downloadPlayStoreImage: require('./img/download_playstore.png'),
  downloadAppStoreImage: require('./img/download_appstore.png'),
  alertErrorImage: require('./img/alert_error.png'),
  alertValidImage: require('./img/alert_valid.png'),
  welcomeEsimImage: require('./img/welcome_esim.png'),
  eSimSwapImage: require('./img/switch_sim_esim.png'),
  giftImage: require('./img/gift.gif'),
  requiredToSignUp: {
    creditcard: {
      useIcon: false,
      image: require('./img/id_cni.png'),
    },
    phone: {
      useIcon: false,
      image: require('./img/phone108_compatible.png'),
    },
    user: {
      useIcon: false,
      image: require('./img/usercheck.png'),
    },
    sim: {
      useIcon: false,
      image:
        Platform.OS === 'web'
          ? require('./img/simcard.png')
          : require('./img/simchoice.png'),
    },
    right_arrow: require('./img/arrow_right.png'),
    left_arrow: require('./img/arrow_left.png'),
  },
  checkboxColor: colors.secondaryColor,
  checkboxTextColor: colors.gray.normal,
  selectedBackground: colors.eighthColor,
  selectedCheckboxColor: colors.secondaryColor,
  clearButtonColor: colors.gray.light,
  separatorColor: colors.gray.light,
  defaultTextColor: colors.tertiaryColor,
  emptyInboxColor: colors.gray.light,
  emptyTextColor: colors.gray.normalLight,
  textOverColoredBackground: colors.overPrimaryColor,
  secondaryButtonColor: inferredColors.transparentPrimaryColor,
  androidStatusBarColor: colors.primaryColor,
  dashboardStatusBarStyle: 'light-content',
  signUpStatusBarStyle: 'dark-content',
  welcomeScreenStatusBarStyle: 'light-content',
  welcomeScreenTextColor: colors.secondaryColor,
  headerBackgroundColor: colors.secondaryColor,
  dashboardHeaderTextColor: colors.overPrimaryColor,
  headerTextColor: colors.primaryColor,
  internationalIconColor: colors.overPrimaryColor,
  internationalIddButtonColor: colors.fourthColor,
  internationalPremiumButtonColor: colors.sixthColor,
  internationalPullToRefreshColor: colors.errorColor,
  internationalRoamingButtonColor: colors.primaryColor,
  internationalRoamingTitleColor: colors.primaryColor,
  internationalRoamLikeHomeButtonColor: colors.secondaryColor,
  internationalTravelButtonColor: colors.fifthColor,
  manageLinesTextColor: colors.gray.normal,
  modeOffNoSubscription: colors.errorColor,
  confirmPlanPriceColor: colors.primaryColor,
  signUpPoweredByColor: colors.gray.normalLight,
  signUpTextColor: colors.secondaryColor,
  signUpDarkTextColor: colors.secondaryColor,
  signUpLightIconColor: colors.gray.normalLight,
  signUpInputTextColor: colors.secondaryColor,
  signUpTextAreaBackgroundColor: inferredColors.veryTransparentSecondaryColor,
  signUpTextAreaPlaceholderColor: inferredColors.transparentSecondaryColor,
  signUpTransparentInputTextColor: inferredColors.transparentSecondaryColor,
  signUpFocusedInputTextColor: colors.secondaryColor,
  signUpTransparentTextColor: inferredColors.transparentPrimaryColor,
  signUpPlaceholderColor: colors.gray.normalWithLessOpacity,
  signUpUnselectedInputBorderColor: colors.gray.normalWithLessOpacity,
  signUpIconInCircleColor: colors.overSecondaryColor,
  signUpIconInCircleBackgroundColor: colors.secondaryColor,
  signUpIconColor: colors.secondaryColor,
  signUpIconBorderColor: colors.primaryColor,
  signUpPhonePicker: colors.secondaryColor,
  signUpDeliveryMethodChoice: colors.secondaryColor,
  signUpSelectedDeliveryMethodChoice: colors.secondaryColor,
  signUpEditPlan: colors.secondaryColor,
  signUpPDPALinkColor: colors.secondaryColor,
  signUpKeepNumberHelpColor: colors.gray.normalLight,
  androidInputSelectionColor: inferredColors.secondaryColor,
  iosInputSelectionColor: colors.secondaryColor,
  transparentIconColor: inferredColors.transparentPrimaryColor,
  digitsInputColor: colors.secondaryColor,
  walletColor: '#EEEEEE',
  earthColor: colors.fourthColor,
  roamingIconColor: colors.primaryColor,
  slidersColor: colors.secondaryColor,
  bottomPanelColor: '#FFFFFF50',
  bottomPanelBorderColor: colors.gray.light,
  gradientColorsPage: [colors.white, colors.white],
  textInput: {
    underlineColor: colors.secondaryColor,
    textColor: colors.secondaryColor,
    placeholderColor: colors.gray.normalLight,
    disabled: {
      underlineColor: colors.white,
      textColor: colors.secondaryColor,
    },
  },
  pageTitle: {
    titleColor: colors.primaryColor,
  },
  choosePlan: {
    serviceOption: {
      priceColor: colors.gray.normalLight,
      selectedPriceColor: colors.primaryColor,
      titleColor: colors.secondaryColor,
      selectedTitleColor: colors.secondaryColor,
      legendColor: colors.secondaryColor,
      selectedLegendColor: colors.secondaryColor,
    },
    footer: {
      labelColor: colors.primaryColor,
      priceColor: colors.primaryColor,
    },
  },
  profile: {
    iconColor: colors.secondaryColor,
  },
  payments: {
    subtitle: {
      color: colors.secondaryColor,
      fontSize: 13,
    },
    meanIcon: {
      color: colors.secondaryColor,
    },
  },
  manageLines: {
    textColor: colors.secondaryColor,
    iconColor: colors.secondaryColor,
    arrowColor: colors.primaryColor,
  },
  contracts: {
    textColor: colors.primaryColor,
    arrowColor: colors.primaryColor,
  },
  pendingDashboard: {
    menuIcon: {
      color: colors.secondaryColor,
    },
  },
  legalBlurb: {
    textColor: colors.gray.normal,
  },
  topUp: {
    header: {
      iconColor: colors.primaryColor,
      backgroundColor: colors.eighthColor,
    },
  },
  listFooterArrow: {
    color: colors.primaryColor,
  },
  errorToast: {
    background: colors.errorBackgroundColor,
    iconAndType: colors.errorColor,
    text: colors.gray.normal,
  },
  messageToast: {
    background: colors.white,
    iconAndType: colors.secondaryColor,
    text: colors.gray.normal,
  },
  radioButton: {
    color: colors.secondaryColor,
    disabled: colors.gray.normalLight,
  },
  simRadioButton: {
    color: colors.secondaryColor,
    disabled: colors.secondaryColor,
  },
  gradientColors: {
    PRIMARY: [colors.primaryColor, colors.primaryColor, colors.primaryColor],
    SECONDARY: [
      colors.tertiaryColor,
      colors.tertiaryColor,
      colors.tertiaryColor,
    ],
  },
  buttons: {
    PRIMARY: {
      backgroundColors: [
        colors.primaryColor,
        colors.primaryColor,
        colors.primaryColor,
      ],
      textColor: colors.white,
    },
    SECONDARY: {
      backgroundColor: colors.secondaryColor,
      borderColor: colors.secondaryColor,
      textColor: colors.white,
    },
    TERTIARY: {
      backgroundColor: colors.white,
      borderColor: colors.tertiaryColor,
      textColor: colors.tertiaryColor,
    },
    LINK: {
      hasRightArrow: true,
      color: colors.primaryColor,
    },
    SUCCESS: {
      backgroundColors: [
        colors.primaryColor,
        colors.primaryColor,
        colors.primaryColor,
      ],
      textColor: colors.white,
    },
    DEFAULT: {
      backgroundColors: [colors.white, colors.white, colors.white],
      borderColor: '#ABABAB',
      textColor: '#ABABAB',
    },
    CANCEL: {
      backgroundColors: [
        colors.secondaryColor,
        colors.secondaryColor,
        colors.secondaryColor,
      ],
      borderColor: colors.secondaryColor,
      textColor: colors.white,
    },
    borderRadius: 5,
  },
  roaming: {
    textColor: colors.gray.normal,
    notFoundTextColor: colors.gray.normalLight,
  },
  onboarding: {
    fullscreenImages: false,
    bulletPointColor: colors.primaryColor,
    chosenBulletColor: colors.primaryColor,
    textColor: colors.primaryColor,
    skipButtonTextColor: colors.primaryColor,
  },
  usages: {
    FACEBOOK_DATA_CREDIT: {
      icon: 'facebook-logo',
      iconColor: colors.secondaryColor,
      borderColor: '#EA39C4',
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    YOUTUBE_DATA_CREDIT: {
      icon: 'youtube',
      iconColor: colors.secondaryColor,
      borderColor: '#EA39C4',
      textColor: colors.secondaryColor,
      gradientborderColor: ['#F50778', '#EA39C4'],
    },
    INSTAGRAM_DATA_CREDIT: {
      icon: 'instagram',
      iconColor: colors.secondaryColor,
      borderColor: '#EA39C4',
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    VOICE_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: '#e63e25',
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    SMS_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: '#e63e25',
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    DATA_CREDIT: {
      icon: 'data',
      iconColor: colors.secondaryColor,
      borderColor: '#e63e25',
      textColor: colors.secondaryColor,
      gradientColors: [colors.fifthColor, colors.fifthColor],
    },
    ROA_VOICE_RDM1_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.fifthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    ROA_SMS_RDM1_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: colors.fifthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    ROA_DATA_RDM1_CREDIT: {
      icon: 'data',
      iconColor: colors.secondaryColor,
      borderColor: colors.fifthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    ROA_VOICE_RDM2_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.fifthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    ROA_SMS_RDM2_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: colors.fifthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    ROA_DATA_RDM2_CREDIT: {
      icon: 'data',
      iconColor: colors.secondaryColor,
      borderColor: colors.fifthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    IDDVOICEA_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    IDDVOICEB_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    IDDSMSA_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    IDDSMSB_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    EXTRA_CREDIT: {
      icon: 'euro',
      iconColor: colors.secondaryColor,
      borderColor: colors.sixthColor,
      textColor: colors.secondaryColor,
      gradientColors: [colors.sixthColor, colors.sixthColor],
    },
    IDD_VOICE_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: [colors.secondaryColor, colors.secondaryColor],
    },
    IDD_VOICE_RDM1_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: [colors.secondaryColor, colors.secondaryColor],
    },
    IDD_VOICE_RDM2_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: [colors.secondaryColor, colors.secondaryColor],
    },
    DATA_AND_EUROPE_CREDIT: {
      icon: 'data',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: [colors.secondaryColor, colors.secondaryColor],
    },
    ROA_DATA_CREDIT: {
      icon: 'international',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: [colors.secondaryColor, colors.secondaryColor],
    },
    IDD_VOICE_D_CREDIT: {
      icon: 'phone-plane',
      iconColor: colors.secondaryColor,
      borderColor: colors.fourthColor,
      textColor: colors.secondaryColor,
      gradientColors: [colors.secondaryColor, colors.secondaryColor],
    },
    DEFAULT: {
      icon: 'star',
      iconColor: colors.secondaryColor,
      borderColor: '#D445DA',
      textColor: colors.secondaryColor,
      gradientColors: ['#E445EA', '#C548FE'],
    },
  },
  catalog: {
    TO_ZONED_VOICE: {
      icon: 'phone-plane',
      color: colors.secondaryColor,
    },
    VOICE: {
      icon: 'phone',
      color: colors.secondaryColor,
    },
    SMS: {
      icon: 'sms',
      color: colors.secondaryColor,
    },
    DATA: {
      icon: 'data',
      color: colors.secondaryColor,
    },
    ROA_DATA: {
      icon: 'international',
      color: colors.secondaryColor,
    },
    EXTRA: {
      icon: 'attach-money',
      color: colors.fourthColor,
    },
    DEFAULT: {
      icon: 'star',
      color: colors.fourthColor,
    },
  },
  IAPPackages: {
    EXTRA: {
      icon: 'payment',
      colors: [colors.seventhColor, colors.seventhColor, colors.seventhColor],
      preventIconReversal: true,
    },
    ROAM_LIKE_HOME: {
      icon: 'paper-plane',
      colors: [colors.fourthColor, colors.fourthColor, colors.fourthColor],
    },
    ROAMING_PACKAGE: {
      icon: 'suitcase',
      colors: [colors.fifthColor, colors.fifthColor, colors.fifthColor],
    },
  },
  orders: {
    SIGNUP: {
      icon: 'registdone',
      color: colors.fourthColor,
      reverse: true,
    },
    CHANGEPLAN: {
      icon: 'refresh',
      color: colors.seventhColor,
    },
    VOUCHER: {
      icon: 'voucher',
      color: colors.fourthColor,
    },
    TOPUP: {
      icon: 'plus',
      color: colors.fifthColor,
    },
    SN3: {
      icon: 'plus',
      color: '#19BA44',
    },
    ACT: {
      icon: 'plus',
      color: '#19BA44',
    },
  },
  timelineItems: {
    ACTIVATION_PAYMENT_KO: {
      icon: 'error',
      color: colors.fourthColor,
    },
    CHANGE_LINE_MODE_OFF: {
      icon: 'toggle-off',
      color: colors.fifthColor,
      reverse: true,
    },
    CHANGE_LINE_MODE_ON: {
      icon: 'toggle-on',
      color: colors.fifthColor,
      reverse: true,
    },
    CHANGEPLAN_OK: {
      icon: 'upgrade-simcard',
      color: colors.seventhColor,
    },
    CHANGEPLAN_CANCELED: {
      icon: 'upgrade-simcard',
      color: colors.seventhColor,
    },
    CHANGEPLAN_SCHEDULED: {
      icon: 'upgrade-simcard',
      color: colors.seventhColor,
    },
    CHANGEPLAN_FUTURE_CANCEL: {
      icon: 'upgrade-simcard',
      color: colors.seventhColor,
    },
    PAYMENT_MEAN_REGISTRATION: {
      icon: 'payment',
      color: colors.fourthColor,
    },
    PAYMENT_MEAN_PATCHED: {
      icon: 'payment',
      color: colors.fourthColor,
    },
    REGISTRATION_OK: {
      icon: 'registdone',
      color: colors.fourthColor,
      reverse: true,
    },
    TOPUP_OK: {
      icon: 'topupdone',
      color: colors.fifthColor,
    },
    TOPUP_KO: {
      icon: 'error',
      color: colors.fifthColor,
    },
    TICKET_UPDATED: {
      icon: 'helpticketanswered',
      color: colors.fifthColor,
      reverse: true,
    },
    TICKET_CREATED: {
      icon: 'helpticket',
      color: colors.fifthColor,
      reverse: true,
    },
    MODEOFF_OK: {
      icon: 'refresh',
      color: colors.fifthColor,
    },
    RENEWAL_OK: {
      icon: 'refresh',
      color: colors.fourthColor,
    },
    VOUCHER_KO: {
      icon: 'voucher',
      color: colors.fifthColor,
    },
    VOUCHER_OK: {
      icon: 'voucher',
      color: colors.fourthColor,
    },
    RESET_PASSWORD_DONE: {
      icon: 'password',
      color: colors.fourthColor,
    },
    RESET_PASSWORD_ASK: {
      icon: 'user',
      color: colors.fifthColor,
    },
    CUSTOMER_CREATION: {
      icon: 'user',
      color: colors.fourthColor,
    },
    CHANGE_PASSWORD: {
      icon: 'password',
      color: colors.fifthColor,
    },
    CHANGE_PERSONAL_INFO: {
      icon: 'edit',
      color: colors.fifthColor,
      reverse: true,
    },
    ACTIVATION_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    ACTIVATION_BONUS_WALLET_CREDIT_OK: {
      icon: 'wallet',
      color: colors.fourthColor,
    },
    WALLET_CREDIT_KO: {
      icon: 'error',
      color: colors.fourthColor,
    },
    WALLET_CREDIT_OK: {
      icon: 'wallet',
      color: colors.fourthColor,
    },
    GOODWILL_OK: {
      icon: 'wallet',
      color: colors.fourthColor,
    },
    GODCHILD_WALLET_CREDIT_OK: {
      icon: 'invitefriend',
      color: colors.fifthColor,
    },
    GODFATHER_WALLET_CREDIT_OK: {
      icon: 'invitefriend',
      color: colors.fifthColor,
    },
    DELIVERY_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    DELIVERY_PREMIUM_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    PORTA_REJECTED: {
      icon: 'error',
      color: colors.fourthColor,
    },
    PORTA_ACTIVATION_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    PORTA_PAYMENT_KO: {
      icon: 'error',
      color: colors.fourthColor,
    },
    SUSPENSION_BY_AGENT_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    SUSPENSION_BY_CUSTOMER_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    TERMINATION_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    REACTIVATION_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    SIM_SWAP_OK: {
      icon: 'simcard',
      color: colors.fourthColor,
    },
    ESIM_SWAP_OK: {
      icon: 'refresh',
      color: colors.sixthColor,
    },
    ACTIVATION_ESIM_OK: {
      icon: 'simcard',
      color: colors.sixthColor,
    },
    PORTA_ACTIVATION_ESIM_OK: {
      icon: 'simcard',
      color: colors.sixthColor,
    },
  },
  doughnutConfig: {
    standardDoughnut: [
      'FACEBOOK_DATA_CREDIT',
      'YOUTUBE_DATA_CREDIT',
      'INSTAGRAM_DATA_CREDIT',
      'DATA_CREDIT',
      'VOICE_CREDIT',
      'SMS_CREDIT',
      'DATA_AND_EUROPE_CREDIT',
    ],
    iddDoughnut: [
      'IDD_VOICE_CREDIT',
      'IDD_VOICE_RDM1_CREDIT',
      'IDD_VOICE_RDM2_CREDIT',
    ],
    travelDoughnut: [
      'ROA_DATA_RDM1_CREDIT',
      'ROA_DATA_RDM2_CREDIT',
      'ROA_SMS_RDM1_CREDIT',
      'ROA_SMS_RDM2_CREDIT',
      'ROA_VOICE_RDM1_CREDIT',
      'ROA_VOICE_RDM2_CREDIT',
    ],
    extraCreditDoughnut: ['EXTRA_CREDIT'],
  },
  defaultFeedback: '#EEEEEE',
  fontFamily: 'Gotham',
  ui,
};
